var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.7363 19.3695C36.7363 28.9626 28.9605 36.739 19.3682 36.739C9.77577 36.7361 2 28.9626 2 19.3695C2 9.77637 9.77577 2 19.3682 2C28.9605 2 36.7363 9.77637 36.7363 19.3695Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9248 24.3925C12.3849 27.5138 15.5739 29.6758 19.2722 29.6758C24.3513 29.6758 28.4684 25.5951 28.4684 20.5637C28.4684 15.5323 24.3513 11.4517 19.2722 11.4517C16.9179 11.4517 14.7702 12.3289 13.1432 13.7693",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.7771 15.9227L13.166 13.7947L15.3505 8.13501",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.9aef59d92f5b603d95a3124bc26a7d5e.svg";
export { ForwardRef as ReactComponent };